/** @jsxImportSource @emotion/react */
import { Layout } from "antd";
import React from "react";
import * as Styles from "./styles";

interface LayoutFormProps {}

type LayoutFormPropsType = React.PropsWithChildren<LayoutFormProps>;
const LayoutFormComponent: React.FC<LayoutFormPropsType> = ({
  children,
}: LayoutFormPropsType) => {
  return (
    <div css={Styles.containerStyle}>
      <Layout css={Styles.cardStyle}>{children}</Layout>
    </div>
  );
};

export const LayoutForm = React.memo(LayoutFormComponent);
